import { CareerPath } from '@backrs_ui/common-ui';

import {
  UserProfileResponse,
  ProfileValueOptionResponse,
  ProfileFields,
  ProfileValueOption,
  StoryDocument,
} from '@backrs_ui/grow-ui/src/redux/profile/profile';

import { ACADEMIC_HELPERS } from './academic.config';
import { CAREER_HELPERS } from './career.config';
import { DOCUMENTS_HELPERS } from './documents.config';
import { FINANCIAL_HELPERS } from './financial.config';
import { HEALTH_HELPERS } from './health.config';
import { INTEREST_HELPERS } from './interest.config';
import { PROFILE_HELPERS } from './profile.config';
import { RELATIONSHIPS_HELPERS } from './relationship.config';

export type ResolverFunction<T> = (
  profile: UserProfileResponse,
  options: ProfileValueOptionResponse,
  isEditView?: boolean,
) => T[];

export const optionResolvers: Partial<
  Record<
    ProfileFields,
    ResolverFunction<string | number | ProfileValueOption | CareerPath | StoryDocument>
  >
> = {
  ...ACADEMIC_HELPERS,
  ...CAREER_HELPERS,
  ...INTEREST_HELPERS,
  ...HEALTH_HELPERS,
  ...RELATIONSHIPS_HELPERS,
  ...FINANCIAL_HELPERS,
  ...PROFILE_HELPERS,
  ...DOCUMENTS_HELPERS,
};
